import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/**
 * Marigold is the action color on this page, with deep plum text on it.
 * Safety Red is reserved for tension (pain list, price rise, the "without" column).
 */
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-5 text-[17px] sm:text-xl rounded-2xl min-h-[64px]' : 'px-5 py-3 text-sm rounded-xl';
  return <a href={href} {...href.startsWith('http') ? {
    target: '_top',
    rel: 'noopener'
  } : {}} className={`inline-flex w-full items-center justify-center text-center gap-2 bg-shuttle hover:bg-shuttle-hover text-ink font-display font-bold tracking-tight shadow-lift hover:-translate-y-0.5 transition-[transform,background-color] duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-court/40 ${sizing} ${className}`} data-id="element-84" data-mp="ll7c3mjbozmg">
      {children}
    </a>;
}